import { Component, EventEmitter, forwardRef, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-expandable-textarea',
  templateUrl: './expandable-textarea.component.html',
  styleUrls: ['./expandable-textarea.component.scss'],
  providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: ExpandableTextareaComponent,
      multi: true
    }]
})
export class ExpandableTextareaComponent implements OnInit, ControlValueAccessor {

  @Input() placeholder: string = 'Start Typing here...';
  @Input() disabled: boolean = false;
  @Input() title?: string;
  @Input() rows: number = 5;
  @Input('jargonLoadingState') jargonLoadingState?: string | string[];

  @Output('change') changeEvent: EventEmitter<string|null> = new EventEmitter<string|null>();
  @Output('saveEvent') saveEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  @ViewChild('expandedModalTml') expandedModalTml?: TemplateRef<any>;
  public expandedModalRef?: NgbModalRef;
  
  public onTouch: VoidFunction = () => {};
  private _value: string | null = null;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  get value(): string | null {
    return this._value;
  }

  set value(val: string | null) {
    if (val !== undefined && this._value !== val) {
      this._value = val ?? null;
      this.onChange(val)
      this.onTouch();
    }
  }

  expand() {
    if (this.expandedModalTml) {
      this.expandedModalRef = this.modalService.open(this.expandedModalTml, { fullscreen: true });
    }
	}

  save() {
    if (this.expandedModalRef) {
      this.expandedModalRef.close();
    }
    this.saveEvent.emit(true);
  }

  registerOnChange(fn: Function) {
    this.onChange = (value) => {
      this.changeEvent.emit(value);
      if (fn) fn(value);
    };
  }

  registerOnTouched(fn: VoidFunction) {
    this.onTouch = fn;
  }
  
  writeValue(value: string | null): void {
    this.value = value;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  @HostListener('focusout')
  onFocusOut() {
    this.onTouch();
  }

  private onChange: (value: string | null) => void = (value) => {
    this.changeEvent.emit(value);
    // Handle any internal functionality we want on change, @TODO perhaps remove if not used
  };
}
